import { render, staticRenderFns } from "./AuthHome.vue?vue&type=template&id=3710347f&"
import script from "./AuthHome.vue?vue&type=script&lang=js&"
export * from "./AuthHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports